import * as cookie from 'cookie'
import { isClient } from '~/utils/envChecks'

export const KAMELEOON_VISITOR_CODE_COOKIE = 'kameleoon_visitor_code'

export const getKameleoonVisitorCode = (): string | null => {
  if (isClient()) {
    return cookie.parse(document.cookie)[KAMELEOON_VISITOR_CODE_COOKIE] ?? null
  }

  return null
}
